import React from 'react';
import Button from './Button';

export function CTAEmbed({ title, description, buttonText }) {
  return (
    <div className="flex relative rounded-[22px] bg-midnight text-white">
      <div
        className={`absolute w-1/2 h-full right-0 top-0 bg-[url('/website/logo-v3/graphics/3-4.svg')] bg-no-repeat rounded-br-[22px] invisible sm:visible`}
        style={{
          backgroundPosition: 'bottom 150% right',
        }}
      />
      <div className="flex flex-col p-6 pr-0 h-full w-full sm:w-1/2 z-[2]">
        <h3 className="!mt-0">{title || 'Form a better life now.'}</h3>
        {description && (
          <p className="!hidden md:!line-clamp-3 text-white/70">
            {description}
          </p>
        )}
        <div className="mt-auto">
          <Button to="/register" solid gold>
            {buttonText || 'Get Started'}
          </Button>
        </div>
      </div>
    </div>
  );
}
